// Resolve a client config value. Reads process.env first (Node + Jest), then
// falls back to Vite's native import.meta.env in the browser. Mirrors the
// dsr-next helper so the VITE_-prefixed convention is shared across apps.
export const getEnvValue = (key: string) => {
  if (typeof process !== "undefined" && process.env && process.env[key]) {
    return process.env[key];
  }

  if (import.meta?.env) {
    return import.meta.env[key];
  }

  return undefined;
};
